module.exports = __webpack_public_path__ + "img/img_home_panel_4.26d1bc5b.jpg";